import { Button } from "@monta/design-system";
import { fixString } from "@monta/router-js";
import type { TUtils } from "@monta/utils";
import clsx from "clsx";
import type { IMenu } from "../../constants";
import Actions from "./actions/Actions";
import styles from "./headerDesktop.module.scss";
import Menu from "./Menu/Menu";

interface HeaderDesktopProps {
  menuItems: IMenu[];
  auth: TUtils["auth"];
  cart: TUtils["cart"];
}

const HeaderDesktop = (props: HeaderDesktopProps) => {
  const { menuItems, auth, cart } = props;

  return (
    <div className={clsx("container", styles["header-desktop"])}>
      <div className={styles["header-desktop__flex-container"]}>
        <Button
          width={"unset"}
          onClick={() => {
            if (auth?.isLoggedIn) {
              auth?.redirectToDefault();
            } else
              Object.assign(window.location, {
                href: fixString("/", "LANDING_URL"),
              });
          }}
        >
          <img
            id="monta-logo"
            height={43}
            width={66}
            alt={"مٌـنتا، آموزش و ارزیابی هوشمند"}
            src={fixString("/montaLogo.png", "LANDING_URL")}
          />
        </Button>
        <Menu menuItems={menuItems} />
      </div>

      <Actions auth={auth} cart={cart} />
    </div>
  );
};

export default HeaderDesktop;
